<script>
import Template from '{Template}/Web/Pages/PeerTrade/CreatePeerTrade.template'
import AppLayout from '@/Layouts/AppLayout'
import IconFilter from "@/Components/Table/IconFilter";

export default Template({
    components: {
        AppLayout,
        IconFilter,
    },
    data() {
        return {
            type: 'buy',
            form: {
                currency: null,
                fiat: null,
                amount: 0,
                min_amount: 0,
                max_amount: 0,
            },
        }
    },
    props: {
        currencies: Object,
    },
    methods: {
        setType(type) {
            this.type = type;
        },
        handleInput ($event, field) {

            let formField = this.form[field];

            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

            if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || formField.toString().indexOf('.') != -1)) {
                $event.preventDefault();
            }

            // restrict to 2 decimal places
            if(formField != null && formField.toString().indexOf(".")>-1 && (formField.toString().split('.')[1].length >= 8)){
                $event.preventDefault();
            }
        },
        clearInput ($event, field) {
            if(this.form[field].toString().charAt(0) == '.') {
                this.form[field] = 0;
            }
        },
    },
})
</script>
